import { render, staticRenderFns } from "./AddCrupier.vue?vue&type=template&id=450c5d70&"
import script from "./AddCrupier.vue?vue&type=script&lang=js&"
export * from "./AddCrupier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports